import React, { PureComponent } from 'react';
import YouTubePlayer from 'react-player/lib/players/YouTube';
import { string } from 'prop-types';
import Loader from '../Loader/Loader';
import StyledVideoPlayer from './VideoPlayer.style';

export const DEFAULT = {
  width: '100%',
  height: '100%'
};

class VideoPlayer extends PureComponent {
  state = {
    isReady: false
  };

  onReady = isReady => {
    this.setState({ isReady });
  };

  renderPlayer = () => {
    const { url, title, ...rest } = this.props;
    let settings = { ...DEFAULT, ...rest };

    // only for YouTube so far
    if (/(youtube\.com|youtu\.be)/.test(url)) {
      settings = { ...settings, url };
      return (
        <YouTubePlayer
          {...settings}
          title={title}
          controls
          onReady={() => {
            this.onReady(true);
          }}
        />
      );
    } else {
      return null;
    }
  };

  render() {
    return (
      <StyledVideoPlayer>
        <Loader disabled={this.state.isReady} />
        {this.renderPlayer()}
      </StyledVideoPlayer>
    );
  }
}

VideoPlayer.propTypes = {
  url: string,
  title: string.isRequired
};

export default VideoPlayer;
